import { Alert, Button, Card, Space, Typography } from 'antd';
import styles from './CrashFallback.module.css';

const { Title, Text } = Typography;

export default function CrashFallback({ errorId, onRetry, onGoHome, onGoBack }) {
  return (
    <div className={styles.wrap} role="alert" aria-live="assertive">
      <Card className={styles.card}>
        <Title level={4}>Something went wrong on this page.</Title>
        <p className={styles.message}>
          The page recovered into safe mode. You can retry this screen or navigate to a stable page.
        </p>
        <Alert
          type="warning"
          showIcon
          message="If this keeps happening, share the error ID with support."
          description={<Text copyable>{errorId}</Text>}
          className={styles.meta}
        />
        <Space className={styles.actions} wrap>
          <Button type="primary" onClick={onRetry}>
            Retry
          </Button>
          <Button onClick={onGoHome}>Go to Dashboard</Button>
          <Button onClick={onGoBack}>Go Back</Button>
        </Space>
      </Card>
    </div>
  );
}
